export default function parseJson(
  str = null,
  defaultValue = {},
  Model = null,
  emptyKeysAllowed = false
) {
  if (!str) return defaultValue
  if (typeof str === 'object' || Array.isArray(str)) return str

  const trimmedStr = str.trim()

  try {
    const parsedData = JSON.parse(trimmedStr)
    const mappedData = Model ? new Model(parsedData) : parsedData

    return emptyKeysAllowed || !mappedData || Array.isArray(mappedData)
      ? mappedData
      : removeEmptyKeys(mappedData)
  } catch (e) {
    return defaultValue
  }
}

function removeEmptyKeys(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value != null)
  )
}
